// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pm-6";
export var imgContainer = "_pm-3";
export var menuIcon = "_pm-5";
export var pillWrapper = "_pm-2";
export var pillsContainer = "_pm-1";
export var subscriptionCard = "_pm-0";
export var subscriptionLogo = "_pm-4";